export default {
  'Title': 'Назва',
  'Slug': 'Slug',
  'Type': 'Тип',
  'Short title': 'Коротка назва',
};
